/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertResolutionStatus } from './ControlZeroDayAlertResolutionStatus';
import {
    ControlZeroDayAlertResolutionStatusFromJSON,
    ControlZeroDayAlertResolutionStatusFromJSONTyped,
    ControlZeroDayAlertResolutionStatusToJSON,
} from './ControlZeroDayAlertResolutionStatus';

/**
 * 
 * @export
 * @interface ControlBulkResolveClientResult
 */
export interface ControlBulkResolveClientResult {
    /**
     * 
     * @type {string}
     * @memberof ControlBulkResolveClientResult
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlBulkResolveClientResult
     */
    company_name?: string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ControlBulkResolveClientResult
     */
    impacted_assets?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlBulkResolveClientResult
     */
    resolved_assets?: Array<string>;
    /**
     * 
     * @type {ControlZeroDayAlertResolutionStatus}
     * @memberof ControlBulkResolveClientResult
     */
    resolution_status?: ControlZeroDayAlertResolutionStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ControlBulkResolveClientResult
     */
    newly_resolved: boolean;
}

/**
 * Check if a given object implements the ControlBulkResolveClientResult interface.
 */
export function instanceOfControlBulkResolveClientResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "newly_resolved" in value;

    return isInstance;
}

export function ControlBulkResolveClientResultFromJSON(json: any): ControlBulkResolveClientResult {
    return ControlBulkResolveClientResultFromJSONTyped(json, false);
}

export function ControlBulkResolveClientResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBulkResolveClientResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
        'company_name': !exists(json, 'company_name') ? undefined : json['company_name'],
        'impacted_assets': !exists(json, 'impacted_assets') ? undefined : json['impacted_assets'],
        'resolved_assets': !exists(json, 'resolved_assets') ? undefined : json['resolved_assets'],
        'resolution_status': !exists(json, 'resolution_status') ? undefined : ControlZeroDayAlertResolutionStatusFromJSON(json['resolution_status']),
        'newly_resolved': json['newly_resolved'],
    };
}

export function ControlBulkResolveClientResultToJSON(value?: ControlBulkResolveClientResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.client_id,
        'company_name': value.company_name,
        'impacted_assets': value.impacted_assets,
        'resolved_assets': value.resolved_assets,
        'resolution_status': ControlZeroDayAlertResolutionStatusToJSON(value.resolution_status),
        'newly_resolved': value.newly_resolved,
    };
}

